import React, { Component } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { Container, Form } from 'react-bootstrap';
import { getISOWeek, formatDate, formatWeek, getWeekDetails, sumMoney, displayStoredDate, deviceLabel, formatAmount } from './../../helper';
import Select from '../../Components/PCSelect';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import axios from "axios";
import Swal from "sweetalert2";
import RemoveIcon from '@mui/icons-material/Delete';
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import { CARD, COL_HEAD, INPUT, LABEL, SELECT_STYLES } from './shared/txStyles';

import AmountInput from '../../Components/AmountInput';
import PageHeader from './shared/PageHeader';
import withRouter from '../../helper/withRouter';
import { recordOpened, recordClosed, recordParamChanged, recordNotFound } from '../../helper/recordLinks';
import RecordParty from './shared/RecordParty';
import OwnEntityField from '../../Components/OwnEntityField';
import { defaultOwnId } from '../../helper/identity';

const BASE_PATH = '/admin/refund-device';   // + '/<PUBLIC_ID>' opens one record (record links, Phase B)
class RefundDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // The user's own shop this form works for (Phase 2): picked at the top when they have several.
            OWN_ID: defaultOwnId('shop', BASE_PATH),

            addSale: false,
            SaleList: [],
            ItemList: [],


            SALE_TO_TYPE: "Customer",
            Warehouse: {
                value: "F4",
                label: "F4"
            },
            SALE_DATE: formatDate(new Date().toDateString()),

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],

            InventoryList: [],
            EMAIL_TO: "",
            isEdit: false,
            ShopList: [],
            SaleToShop: "",
            SaleToWarehouse: "",

            // new
            SALE_WEEK: formatWeek(),
            shopPaymentDays: []
        };
        this.gridRef = React.createRef(null);
    }


    // componentDidMount() {
    //     this.getShopSale()
    //     this.getInventory()
    // }

    async getShopSale(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            REF_SHOP_ID: this.ownId() || 0,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getAllSale = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/ShopModule/PCGetGridShopRefund.php`, formData);
        let SaleData = getAllSale.data
        let SaleList = []
        if (SaleData.success === 1) {
            SaleList = SaleData.data
            pagination.totalItems = parseInt(SaleData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ SaleList })
        this.props.toggleLoader(false)
    }


    async getInventory() {
        let formData = {
            PC_SP_ID: this.ownId() || 0,
            PC_ITEM_STATUS: "Sold"
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getShopInventory.php`, formData);
        let serviceData = getAllInventory.data

        let ItemList = []
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            for (let i = 0; i < InventoryList.length; i++) {
                const element = InventoryList[i];
                ItemList.push({
                    'ItemBrand': element.ItemBrand,
                    'ItemType': element.ItemType,
                    'display': element.ItemName,
                    'label': `${element.ItemName} (${element.ItemIMEI}) ${element.ItemDesc}`,
                    'value': element.ItemIMEI,
                    'id': element.ItemIMEI
                })
            }

        }
        this.setState({ InventoryList, ItemList })

    }

    async hanldeAddSale() {

        let weekDetails = getWeekDetails();
        let shopPaymentDays = []
        if (weekDetails.dates.length > 0) {
            for (let i = 0; i < weekDetails.dates.length; i++) {
                const WeekPerDay = weekDetails.dates[i];
                shopPaymentDays.push({
                    'DateAndDay': WeekPerDay
                })
            }
        }

        this.setState({
            shopPaymentDays,
            SALE_WEEK: weekDetails.weekId,
            SALE_DATE: formatDate(new Date().toDateString()),
            addSale: true,
            isEdit: false
        })

        this.getInventory()
    }

    handleSearchgridData() {

    }

    /* ── Own shop (Phase 2, 2026-11-02) ──
     * A saved record works with ITS shop (set when it opens); a new one with the shop picked at
     * the top (OwnEntityField — only the user's own; one shop: shown, locked). */
    ownId() {
        return this.recordOwner || this.state.OWN_ID || localStorage.getItem('PC_GRP_ATT') || '';
    }

    // A different shop for the new record: its stock / vendors are reloaded and items already
    // added are cleared, so nothing from another shop is carried over.
    handleOwnChange(id) {
        this.setState({ OWN_ID: String(id), AddedItemList: [] }, () => this.getInventory());
    }

    /* ── Per-record links: /admin/refund-device/<PUBLIC_ID> ── */
    componentDidMount() {
        const pid = this.props.params?.publicId;
        if (pid) this.openByPublicId(pid);
    }

    componentDidUpdate(prevProps) {
        recordParamChanged(this, prevProps, (pid) => this.openByPublicId(pid), () => this.handleExit());
    }

    // The record behind a link, from the same list endpoint with the server applying the signed-in
    // user's scope (only this shop's / warehouse's own records) — then the same form the list opens.
    async openByPublicId(pid) {
        this.openPid = pid;
        this.props.toggleLoader(true);
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/ShopModule/PCGetGridShopRefund.php`, {
                REF_SHOP_ID: this.ownId() || 0, PUBLIC_ID: pid,
            });
            const row = res.data?.success === 1 ? res.data.data[0] : null;
            this.props.toggleLoader(false);
            if (!row) return recordNotFound(this, BASE_PATH);
            this.recordOwner = String(row.REF_SHOP_ID);
            await this.handleUpdateSale(row);
        } catch (error) {
            this.props.toggleLoader(false);
            console.error('openByPublicId error:', error);
            recordNotFound(this, BASE_PATH);
        }
    }

    // The list's view / edit button: the same form as before, and the record's link in the address bar.
    openFromList(row) {
        recordOpened(this, BASE_PATH, row.PUBLIC_ID);
        this.recordOwner = String(row.REF_SHOP_ID);
        this.handleUpdateSale(row);
    }

    handleUpdateSale(historyRow) {
        // let { SaleList } = this.state
        let SaleData = historyRow
        this.setState({
            isEdit: true,
            addSale: true,

            SALE_WEEK: SaleData.REF_WEEK,
            SALE_DATE: SaleData.REF_DATE,
            AddedItemList: JSON.parse(SaleData.REF_ITEM),
            shopPaymentDays: JSON.parse(SaleData.REF_DAY)
        })
    }

    handleChangeTotalRecords() {

    }

    handleChangePagination() {

    }

    handleChangeUpdatedItem(fieldName, evt, evtA) {
        let { Item, InventoryList } = this.state;
        Item['ItemQuantity'] = 1
        Item['ItemDisc'] = 0
        switch (fieldName) {
            case 'ItemName':
                let findInventory = InventoryList.filter(x => x.ItemIMEI === evt.value)?.[0]
                Item['ItemName'] = evt
                Item['ItemRate'] = parseInt(findInventory.ItemSellRate)
                Item['ItemAmount'] = parseInt(findInventory.ItemSellRate)
                Item['ItemIMEI'] = findInventory.ItemIMEI
                Item['ItemDesc'] = findInventory.ItemDesc
                break;

            case 'ItemDisType':
                Item['ItemDisType'] = evtA
                if (evtA === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (Item['ItemDisc'] / 100))
                }
                break;
            case 'ItemQuantity':
                Item[evt.target.name] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (evt.target.value * Item['ItemRate']) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (evt.target.value * Item['ItemRate']) - ((evt.target.value * Item['ItemRate']) * (Item['ItemDisc'] / 100))
                }
                break;
            case 'ItemRate':
                Item[evt.target.name] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * evt.target.value) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * evt.target.value) - ((Item['ItemQuantity'] * evt.target.value) * (Item['ItemDisc'] / 100))
                }
                break;

            case 'ItemDisc':
                Item[evt.target.name] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - evt.target.value
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (evt.target.value / 100))
                }
                break;

            case 'ItemIMEI':
                // let findInventory = InventoryList.filter(x => x.PC_ITEM_BARCODE === evt.target.value || x.PC_ITEM_BARCODE === evt.target.value)?.[0]
                Item[evt.target.name] = evt.target.value
                break;

            default:
                Item[evt.target.name] = evt.target.value
                break;

        }
        this.setState({ Item })
    }


    handleValidateItem(Item, AddedItemList, ItemList) {
        if (Item.ItemName === '' || Item?.ItemName?.value === "") {
            Swal.fire(
                'Error',
                'Please select Item',
                'error'
            )
            return false
        }
        if (Item.ItemRate === '' || parseInt(Item.ItemRate) <= 0) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.ItemQuantity === '' || parseInt(Item.ItemQuantity) <= 0) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }

        for (let i = 0; i < AddedItemList.length; i++) {
            const ItemList = AddedItemList[i];
            if (ItemList.ItemIMEI === Item.ItemIMEI) {
                let RefreshItem = {
                    ItemName: "",
                    ItemIMEI: "",
                    ItemDesc: "",
                    ItemRate: 0,
                    ItemQuantity: 0,
                    ItemDisc: 0,
                    ItemAmount: 0,
                    ItemDisType: "number"
                }
                this.setState({ Item: RefreshItem })
                Swal.fire(
                    'Error',
                    'Device already exists on sale list',
                    'error'
                )
                return false
            }
        }

        let a = ItemList.filter(x => x.id === Item.ItemIMEI)
        if (a.length === 0) {
            let RefreshItem = {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            }
            this.setState({ Item: RefreshItem })
            Swal.fire(
                'Error',
                'No device found on inventory',
                'error'
            )
            return false
        }


        return true
    }

    handleAddItem() {
        let { Item, AddedItemList, ItemList } = this.state
        if (!this.handleValidateItem(Item, AddedItemList, ItemList)) return
        let UpdateItemList = [Item].concat(AddedItemList)
        this.setState({ AddedItemList: UpdateItemList })
        let RefreshItem = {
            ItemName: "",
            ItemIMEI: "",
            ItemDesc: "",
            ItemRate: 0,
            ItemQuantity: 0,
            ItemDisc: 0,
            ItemAmount: 0,
            ItemDisType: "number"
        }
        this.setState({ Item: RefreshItem })

    }

    async handleChange(fieldName, evt) {
        let value
        switch (fieldName) {
            case 'SALE_WEEK':
                value = evt.target.value
                let WeekNumber = evt.target.value;
                let weekYearArr = WeekNumber.split("-");
                weekYearArr[1] = weekYearArr[1].replace("W", "");
                let MappedValue = weekYearArr.map(n => parseInt(n)).reverse();
                let WeekOut = await getISOWeek(...MappedValue)
                let shopPaymentDays = []
                let SALE_DATE = "";
                if (WeekOut.length > 0) {
                    SALE_DATE = formatDate(WeekOut[0]);
                    for (let i = 0; i < WeekOut.length; i++) {
                        const WeekPerDay = WeekOut[i];
                        shopPaymentDays.push({
                            'DateAndDay': WeekPerDay
                        })
                    }
                }
                this.setState({ shopPaymentDays, SALE_DATE })

                break;
            case 'Warehouse':
                value = evt
                break;
            case 'SaleToShop':
            case 'SaleToWarehouse':
                // fieldName = "Customer"
                value = evt
                break;
            default:
                value = evt.target.value
                break;
        }
        this.setState({
            [fieldName]: value
        })
    }

    ValidateInvoice() {
        if (this.state.AddedItemList.length === 0) {
            Swal.fire(
                'Error',
                'Please Add atleast 1 Item',
                'error'
            )
            return false
        }
        return true
    }

    async handleSaveInvoice() {
        if (!this.ValidateInvoice()) return

        let formData = {
            REF_ID: "",
            REF_SHOP_ID: this.ownId(),
            REF_DAY: JSON.stringify(this.state.shopPaymentDays),
            REF_WEEK: this.state.SALE_WEEK,
            REF_DATE: this.state.SALE_DATE,
            REF_ITEM: JSON.stringify(this.state.AddedItemList),
            REF_TOTAL_AMT: this.renderTotalAmount()
        }

        try {
            let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/ShopModule/PCRefundShopDevice.php`, formData);
            if (getSaleInvoiceResult.data.status === 200) {
                Swal.fire(
                    'Success',
                    getSaleInvoiceResult.data.message,
                    'success'
                )
            } else {
                Swal.fire(
                    'Error',
                    getSaleInvoiceResult.data.message,
                    'error'
                )
            }
            this.handleExit()
        } catch (error) {
            console.error('error :>> ', error);
        }
    }

    handleValidate() {
        if (this.state.EMAIL_TO === "") {
            Swal.fire(
                'Error',
                'Please Enter Email Address',
                'error'
            )
            return false
        }
        return true
    }

    async handleSendEmail() {

        if (!this.handleValidate()) return

        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: this.ownId(),
            SALE_CUSTOMER: this.state.Customer,
            SALE_WAREHOUSE: this.state.Warehouse.value,
            SALE_DATE: this.state.SALE_DATE,
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            EMAIL_TO: this.state.EMAIL_TO
        }
        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}mail/SendMail.php`, formData);
        if (getSaleInvoiceResult.data.status === 201) {
            Swal.fire(
                'Success',
                'Email has been send!!',
                'success'
            )
        }
    }

    handleExit() {
        recordClosed(this, BASE_PATH);
        this.recordOwner = null;
        this.setState({
            addSale: false,
            ItemList: [],

            Customer: "",
            Warehouse: {},
            SALE_DATE: formatDate(new Date().toDateString()),

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],
            isEdit: false,
            SaleToShop: ""
        })
        this.getShopSale()
    }

    renderTotalAmount() {
        let { AddedItemList } = this.state;
        let Price = sumMoney(AddedItemList, "ItemAmount");
        return Price
    }

    handleKeyPress(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddItem()
        }
    }

    handleEnterImei(evnt) {
        if (evnt.key === 'Enter') {
            let { Item, InventoryList } = this.state;
            let FilterItem = InventoryList.filter(x => x.ItemIMEI === Item.ItemIMEI)
            if (FilterItem.length > 0) {
                Item['ItemName'] = {
                    'display': FilterItem[0].ItemName,
                    'label': `${FilterItem[0].ItemName} (${FilterItem[0].ItemIMEI})`,
                    'value': FilterItem[0].ItemIMEI,
                    'id': FilterItem[0].ItemIMEI,
                }
                Item['ItemDesc'] = FilterItem[0].ItemDesc
                Item['ItemRate'] = FilterItem[0].ItemSellRate
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                Item['ItemAmount'] = (1 * FilterItem[0].ItemSellRate) - ((1 * FilterItem[0].ItemSellRate) * (0 / 100))
            }
            this.setState({ Item }, () => { this.handleAddItem() })
        }
    }

    handleRemove(index) {
        let { AddedItemList } = this.state;
        AddedItemList.splice(index, 1)
        this.setState({ AddedItemList })
    }


    render() {
        const { addSale } = this.state;
        let { Item, shopPaymentDays } = this.state;
        const isLocked = this.state.isEdit;
        const weekLabel = shopPaymentDays.length > 0
            ? shopPaymentDays[0]['DateAndDay'] + ' - ' + shopPaymentDays[6]['DateAndDay']
            : '';

        if (!addSale) {
            return (
                <Container fluid style={{ padding: '24px' }}>
                    <PhoneClinicGrid
                        title="REFUND"
                        buttonLabel="ADD REFUND"
                        ref={this.gridRef}
                        getData={this.getShopSale.bind(this)}
                        onClickButton={this.hanldeAddSale.bind(this)}
                        isEditable={true}
                        tableHeadData={[
                            { label: "DATE", isHidden: false },
                            { label: "DEVICE", isHidden: false },
                            { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                        ]}
                    >
                        {/* One row per record (flattened 2026-10-22). Refund columns follow the sale/purchase standard,
                            limited to what a refund stores: no status, and device refunds record no counterparty. */}
                        {this.state.SaleList.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{displayStoredDate(row.REF_DATE)}</TableCell>
                                <TableCell>{deviceLabel(row.REF_ITEM)}</TableCell>
                                <TableCell align="right"><strong>£ {formatAmount(row.REF_TOTAL_AMT)}</strong></TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'view', onClick: this.openFromList.bind(this, row) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        return (
            <Container fluid style={{ padding: '24px', background: '#f8f9ff', minHeight: '100vh' }}>
                {/* Header */}
                <PageHeader title="Refund Device" subtitle={weekLabel} style={{ margin: "0 0 16px" }} />

                {/* Input Card */}
                {/* The shop this record is for (Phase 2): own only; locked once saved. */}
                <OwnEntityField kind="shop" screen={BASE_PATH} value={this.ownId()} disabled={!!this.recordOwner || !!this.state.isEdit} onChange={this.handleOwnChange.bind(this)} />
                {/* A saved record: its party, date (and description) stay visible, disabled (2026-11-02). */}
                {isLocked && <RecordParty items={[{ label: 'Date', value: displayStoredDate(this.state.SALE_DATE) }]} />}
                {!isLocked && (
                    <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
                        <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                <div>
                                    <label style={LABEL}>WEEK</label>
                                    <WeekRangeSelect menuPortalTarget={document.body} menuPlacement="auto" value={this.state.SALE_WEEK} onChange={this.handleChange.bind(this, 'SALE_WEEK')} />
                                </div>
                                <div>
                                    <label style={LABEL}>ITEM</label>
                                    <Select menuPortalTarget={document.body} name="ItemName" menuPlacement="auto" styles={SELECT_STYLES} value={Item['ItemName']} options={this.state.ItemList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemName')} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                <div>
                                    <label style={LABEL}>DATE</label>
                                    <Form.Control type="date" name="SALE_DATE" style={INPUT}
                                        min={shopPaymentDays.length > 0 ? formatDate(shopPaymentDays[0]['DateAndDay']) : ''}
                                        max={shopPaymentDays.length > 0 ? formatDate(shopPaymentDays[6]['DateAndDay']) : ''}
                                        value={this.state.SALE_DATE} onChange={this.handleChange.bind(this, 'SALE_DATE')} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, justifyContent: 'flex-end' }}>
                                <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                    <div>
                                        <label style={LABEL}>RATE</label>
                                        <AmountInput name="ItemRate" style={{ ...INPUT, color: '#64748b' }} disabled value={Item['ItemRate']} />
                                    </div>
                                    <div>
                                        <label style={LABEL}>AMOUNT</label>
                                        <AmountInput style={{ ...INPUT, fontWeight: 700, color: '#a32f2f' }} disabled value={Item['ItemAmount']} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pc-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr auto', gap: 16, alignItems: 'flex-end' }}>
                            <div>
                                <label style={LABEL}>IMEI / BARCODE</label>
                                <Form.Control name="ItemIMEI" style={INPUT} value={Item['ItemIMEI']} onKeyPress={this.handleEnterImei.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemIMEI')} />
                            </div>
                            <div>
                                <label style={LABEL}>DESCRIPTION</label>
                                <Form.Control name="ItemDesc" style={INPUT} value={Item['ItemDesc']} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDesc')} />
                            </div>
                            <Button variant="contained" style={{ height: 42, whiteSpace: 'nowrap' }} onClick={this.handleAddItem.bind(this)}>ADD ITEM</Button>
                        </div>
                    </div>
                )}

                {/* Table Card */}
                <div style={{ ...CARD, marginBottom: 16 }}>
                    <Table size="small" className="pc-card-table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={COL_HEAD}>NAME</TableCell>
                                <TableCell style={COL_HEAD}>IMEI / BARCODE</TableCell>
                                <TableCell style={COL_HEAD}>RATE</TableCell>
                                <TableCell style={COL_HEAD}>AMOUNT</TableCell>
                                {!isLocked && <TableCell style={COL_HEAD}>ACTION</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.AddedItemList.map((ItemDetails, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{ItemDetails.ItemName?.display}</TableCell>
                                    <TableCell>{ItemDetails.ItemIMEI}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemRate)}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemAmount)}</TableCell>
                                    {!isLocked && (
                                        <TableCell>
                                            <IconButton size="small" onClick={this.handleRemove.bind(this, idx)}>
                                                <RemoveIcon />
                                            </IconButton>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                        <tfoot>
                            <tr>
                                <td colSpan={3} style={{ padding: '12px 16px', fontWeight: 700, color: '#64748b', fontSize: 12, textTransform: 'uppercase' }}>Net Refund</td>
                                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1e293b' }}>£ {formatAmount(this.renderTotalAmount())}</td>
                                {!isLocked && <td />}
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* Footer */}
                <div style={{ ...CARD, padding: '16px 20px', display: 'flex', gap: 8 }}>
                    <Button variant="outlined" onClick={this.handleExit.bind(this)}>EXIT</Button>
                    {!isLocked && (
                        <Button variant="contained" onClick={this.handleSaveInvoice.bind(this)}>SAVE</Button>
                    )}
                </div>
            </Container>
        );
    }
}

export default withRouter(RefundDevice);
